import { render, staticRenderFns } from "./list-v-cover-title.vue?vue&type=template&id=256aa27d&scoped=true"
import script from "./list-v-cover-title.vue?vue&type=script&lang=js"
export * from "./list-v-cover-title.vue?vue&type=script&lang=js"
import style0 from "./list-v-cover-title.vue?vue&type=style&index=0&id=256aa27d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "256aa27d",
  null
  
)

export default component.exports